import type * as THREE from 'three';
import type { FrontVisibilityLayer } from './frontVisibility';

export type PremiumDetailId = 'square-front-door';
export type PremiumTargetGroup = FrontVisibilityLayer;

export interface PremiumDetailPlacement {
  id: PremiumDetailId;
  openingId: string;
  assetPath: string;
  targetGroup: PremiumTargetGroup;
  position: THREE.Vector3;
  rotation: THREE.Euler;
  scale: THREE.Vector3;
  fallbackObjectName: string;
}

/**
 * A procedural part the viewer may swap for a modelled asset once it has
 * downloaded. Unlike a placement it travels with the object itself, so it
 * survives subsystem rebuilds and inherits any pivot rotation or scale.
 * The asset is added beside the slot, with `origin` (slot-local) as its
 * origin, and the slot is hidden; until then the procedural part stays.
 */
export interface PremiumSlot {
  assetPath: string;
  origin: [number, number, number];
}

const PREMIUM_SLOT_KEY = 'premiumSlot';

/** Generic tower heater, built by scripts/blender/electric-heater.py. */
export const ELECTRIC_HEATER_ASSET_PATH = '/assets/premium/heater/electric-tower.glb';

/** Generic wood-fired stove, built by scripts/blender/wood-heater.py. */
export const WOOD_HEATER_ASSET_PATH = '/assets/premium/heater/wood-stove.glb';

/**
 * Regnhuv, built by scripts/blender/chimney-parts.py on a Ø280 pipe end; the
 * engine scales it in plan to the Ø220 chimney.
 */
export const CHIMNEY_CAP_ASSET_PATH = '/assets/premium/chimney/rain-cap.glb';

export function markPremiumSlot(object: THREE.Object3D, slot: PremiumSlot): void {
  object.userData[PREMIUM_SLOT_KEY] = slot;
}

export function readPremiumSlot(object: THREE.Object3D): PremiumSlot | undefined {
  return object.userData[PREMIUM_SLOT_KEY] as PremiumSlot | undefined;
}
